import React from 'react';
import $ from 'jquery';
import _ from 'lodash';

import 'react-select/scss/default.scss';
import './ChannelsModal.scss';
import reducerStore from '../../reducers/reducerStore';

import ChannelList from '../ChannelList/ChannelList';

class ChannelsModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = { createChannel: false, newChannelName: '' };

        this.closeModal = this.closeModal.bind(this);
        this.toggleNewChannel = this.toggleNewChannel.bind(this);
        this.createNewChannel = this.createNewChannel.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
    }

    closeModal() {
        if (this.state.createChannel) {
            this.setState({createChannel: false})
        } else {
            reducerStore.dispatch({ type: 'CHANGE CHANNEL', tvIndex: this.props.tvIndex, showChannelsModal: false });
        }
    }

    toggleNewChannel() {
        this.setState({ createChannel: !this.state.createChannel })
    }

    createNewChannel() {
        const { slides, licenses, updateTvNames } = this.props;
        const { newChannelName } = this.state;
        
        const tvIndexes = _(slides).map('tvIndex').uniq().value();
        const tvIndex = _.first(_.difference(_.range(1, licenses+1), tvIndexes));

        updateTvNames(tvIndex, this.state.newChannelName.length > 0 ? this.state.newChannelName : undefined);
        reducerStore.dispatch({ type: 'CREATE NEW SLIDE', tvIndex, showChannelsModal: false});
    }

    updateChannelName(e) {
        this.setState({
            newChannelName: e.target.value
        });
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.createNewChannel();
        }
    }

    render() {
        const {licenses, companyProfile, currency, slides, slidesData, tvIndex, tvNames} = this.props;
        const {createChannel} = this.state;

        const channels = _(slides)
            .orderBy('position', 'asc')
            .groupBy(slide => slide.tvIndex)
            .value();

        return (
            <div className='container'>
                <div className='channels-overlay'>
                </div>
                <div className='channels-modal'>
                    {tvIndex && <div className="close-modal-btn" onClick={this.closeModal} >
                        <i className="fa fa-times" aria-hidden="true"/>
                    </div>}
                    {createChannel ?
                    <div className="holder">
                        <h1 className="">Skapa ny kanal</h1>
                        <div>
                            <input 
                                autoFocus
                                ref={(input) => { this.channelName = input;}} 
                                onChange={e => this.updateChannelName(e)} 
                                onKeyPress={this._handleKeyPress}
                                placeholder="Välj ett namn för kanalen" />
                            <div className="create-channel" onClick={ () => this.createNewChannel()}>
                                <span>Skapa</span>
                            </div>
                            <div className="cancel-channel" onClick={ () => this.setState({createChannel: false})}>
                                <span>Avbryt</span>
                            </div>
                        </div>
                    </div> 
                    :
                    <div className='inner-box'> 
                        <h1 style={{display: tvIndex ? 'none' : 'inherit'}}>Välkommen!</h1>
                        <div className='channels-info' style={{paddingTop: tvIndex ? '250px' : '0px'}}>
                            <h2 className='setting-header'>Alla kanaler</h2>
                            <p className='licences'>{_.size(channels)}/{licenses || '1'}</p>
                        </div>
                        <ChannelList
                            licenses={licenses}
                            companyProfile={companyProfile}
                            currency={currency}
                            channels={channels}
                            slides={slides}
                            slidesData={slidesData}
                            openNewChannelModal={this.toggleNewChannel}
                            selectChannel={this.selectChannel}
                            startSlideshow={this.props.startSlideshow}
                            tvIndex={tvIndex}
                            tvNames={tvNames}
                        />
                    </div>}
                </div>
            </div>
        );
    }
}

ChannelsModal.propTypes = {
    companyProfile: React.PropTypes.object,
    currency: React.PropTypes.string,
    currentSlideId: React.PropTypes.string,
    licenses: React.PropTypes.number,
    slides: React.PropTypes.array,
    slidesData: React.PropTypes.object,
    startSlideshow: React.PropTypes.func,
    tvIndex: React.PropTypes.number,
    tvNames: React.PropTypes.array,
    updateTvNames: React.PropTypes.func,
};

export default ChannelsModal;



/** WEBPACK FOOTER **
 ** ./client/components/ChannelsModal/ChannelsModal.jsx
 **/